export default __webpack_public_path__ + "static/media/icon7.9e9b353d.svg";